var _rect, _rect2, _rect3, _rect4, _rect5, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKuCoinSmallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.719727,
    y: 2.93164,
    width: 2.97949,
    height: 14.3418,
    rx: 1.46436,
    fill: "#2DBD96"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.89355,
    y: 2.91797,
    width: 2.97758,
    height: 8.95218,
    rx: 1.46436,
    transform: "rotate(-45 8.89355 2.91797)",
    fill: "#2DBD96"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2246,
    y: 10.9473,
    width: 2.97949,
    height: 8.9432,
    rx: 1.46436,
    transform: "rotate(45 15.2246 10.9473)",
    fill: "#2DBD96"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9521,
    y: 0.839844,
    width: 2.97949,
    height: 15.1655,
    rx: 1.46436,
    transform: "rotate(45 10.9521 0.839844)",
    fill: "#2DBD96"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.228516,
    y: 8.65625,
    width: 2.97949,
    height: 15.1655,
    rx: 1.46436,
    transform: "rotate(-45 0.228516 8.65625)",
    fill: "#2DBD96"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9639,
    cy: 10.1191,
    r: 1.49023,
    fill: "#2DBD96"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuCoinSmallIcon);
export default __webpack_public_path__ + "static/media/kuCoinSmallIcon.e1abc9f329a228c0ddc2961fcc83fd17.svg";
export { ForwardRef as ReactComponent };